"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapViewPermaLink = void 0;
var MapViewPermaLink = /** @class */ (function () {
    function MapViewPermaLink(_map, _urlSettingsProvider, _textPack, _settingsOverride, _elementId) {
        if (_settingsOverride === void 0) { _settingsOverride = {}; }
        if (_elementId === void 0) { _elementId = "placeholder-mapViewPermaLink"; }
        var _this = this;
        this._map = _map;
        this._urlSettingsProvider = _urlSettingsProvider;
        this._textPack = _textPack;
        this._settingsOverride = _settingsOverride;
        this._elementId = _elementId;
        this._initialised = false;
        this.init = function () {
            if (!_this._initialised) {
                _this._element = $("#".concat(_this._elementId));
                _this.initHtml();
                _this.addHandlers();
                _this._initialised = true;
            }
        };
        this.initHtml = function () {
            //********************************************
            // Comment out until we have url shortener
            //********************************************
            //        let html = `
            //<div class="mb-2">
            //    <button id="mapViewPermalinkButton" class="btn btn-tools" data-bs-toggle="modal" data-bs-target="#permalinkModal">
            //        <i class="fas fa-link"></i>
            //        <span>${this._textPack.permalink}</span>
            //    </button>
            //</div>
            //<div class="modal fade" data-backdrop="false" id="permalinkModal" tabindex="-1" role="dialog" aria-labelledby="permaLinkModalLabel" aria-hidden="true">
            //  <div class="modal-dialog" role="document">
            //    <div class="modal-content">
            //      <div class="modal-header">
            //        <h5 class="modal-title" id="permaLinkModalLabel">${this._textPack.permalink}</h5>
            //        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            //          
            //        </button>
            //      </div>
            //      <div class="modal-body">
            //        <span id="mapLinkToCopy"></span>
            //        <!-- hidden placeholder text area for copy -->
            //        <span id="clipBoardPlaceHolder" style="opacity:0"></span>
            //      </div>
            //      <div class="modal-footer">        
            //        <button type="button" data-bs-toggle="tooltip" title="Copy to clipboard" id="btnPermaLinkCopyClipboard" class="btn btn-primary"><i class="far fa-clipboard"></i>&nbsp;${this._textPack.copyToClipboard}</button>
            //      </div>
            //    </div>
            //  </div>
            //</div>
            //`;
            var html = "\n        <div class=\"mb-2\">\n            <button id=\"mapViewPermalinkButton\" class=\"btn btn-tools\" data-bs-toggle=\"tooltip\" title=\"Copy to clipboard\">\n                <i class=\"fas fa-link\"></i>\n                <span>".concat(_this._textPack.permalink, "</span>\n            </button>\n\n            <!-- hidden placeholder text area for copy -->\n            <span id=\"clipBoardPlaceHolder\" style=\"opacity:0\"></span>\n        </div>\n        ");
            _this._element.append(html);
        };
        this.getQueryString = function () {
            var mapInfo = _this._map.mapStore.getMapInfo();
            var settings = __assign(__assign({}, mapInfo), _this._settingsOverride);
            return _this._urlSettingsProvider.getQueryString(settings);
        };
        this.addHandlers = function () {
            var self = _this;
            //Remove comments once we have url shortener
            //$('#mapViewPermalinkButton').on('click', function () {
            //    self._link = self.getQueryString();
            //    $("#mapLinkToCopy").html(self._link);                      
            //});
            //$('#btnPermaLinkCopyClipboard').on('click', function () {
            //    var el = $(this);           
            //    self.copyToClipboard(self._link, el, "clipBoardPlaceHolder");
            //});
            $('#mapViewPermalinkButton').on('click', function () {
                var el = $(this);
                self._link = "".concat(window.location.origin).concat(window.location.pathname, "?").concat(self.getQueryString());
                self.copyToClipboard(self._link, el, "clipBoardPlaceHolder");
            });
            $('[data-bs-toggle="tooltip"]').tooltip();
        };
        this.copyToClipboard = function (text, el, placeHolderId) {
            var copyTest = document.queryCommandSupported('copy');
            var elOriginalText = el.attr('data-bs-original-title');
            var self = _this;
            if (copyTest === true) {
                var ph = document.getElementById("clipBoardPlaceHolder");
                var copyTextArea = document.createElement("textarea");
                copyTextArea.value = text;
                ph.appendChild(copyTextArea);
                //document.body.appendChild(copyTextArea);
                copyTextArea.select();
                ;
                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'Copied!' : 'Whoops, not copied!';
                    el.attr('data-bs-original-title', msg).tooltip('show');
                    self.shake(el, 3, 7, 800);
                }
                catch (err) {
                    console.log('Oops, unable to copy');
                }
                ph.removeChild(copyTextArea);
                //document.body.removeChild(copyTextArea);
                el.attr('data-bs-original-title', elOriginalText);
            }
            else {
                // Fallback if browser doesn't support .execCommand('copy')
                window.prompt("Copy to clipboard: Ctrl+C or Command+C, Enter", text);
            }
        };
        //just some fun
        this.shake = function (ele, intShakes, intDistance, intDuration) {
            ele.each(function () {
                $(this).css("position", "relative");
                for (var x = 1; x <= intShakes; x++) {
                    $(this).animate({ left: (intDistance * -1) }, (((intDuration / intShakes) / 4)))
                        .animate({ left: intDistance }, ((intDuration / intShakes) / 2))
                        .animate({ left: 0 }, (((intDuration / intShakes) / 4)));
                }
            });
            //return this;
        };
        this.init();
    }
    return MapViewPermaLink;
}());
exports.MapViewPermaLink = MapViewPermaLink;
//# sourceMappingURL=MapViewPermaLink.js.map